import { useLocation } from 'react-router-dom';

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const qs = new URLSearchParams(useLocation().search);
  return urlSearchToObject(qs);
}

const urlSearchToObject = (params) =>
  [...params.entries()].reduce((acc, tuple) => {
    const [key, val] = tuple;
    // Check if the value is already in the object to convert it to an array and
    // add the value
    if (acc.hasOwnProperty(key)) {
      if (Array.isArray(acc[key])) {
        acc[key] = [...acc[key], val];
      } else {
        acc[key] = [acc[key], val];
      }
    } else {
      // Sort_desc should be parsed to be used as boolean.
      acc[key] = key === 'sort_desc' ? val.toLowerCase() === 'true' : val;
    }

    return acc;
  }, {});

export default useQuery;
